import React, { useEffect, useState,} from "react";
import "../planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import {
  HealthQuestions,
} from "../../../Redux/actions/NumHealth";
import {
  Button,
  Form,
  Radio,
  Checkbox,
  Select,
  Input,
} from "antd/lib";
import NullQuestions from "./QuestionNull";
import Questions from "./Questions";
export default function MedicalQuestionSpouse({ setShowStep3, showStep3,NoForAll, Ref3 }) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const PersonsDetail = useSelector((state) => state?.healthdetail?.famdetail?.healthdetail);
  const StoredQuestions = useSelector((state) => state?.healthdetail?.questions);
  const AddressDetail = useSelector((state) => state?.addressdetail?.info1);
  const [loading, setLoading] = useState(false);
  const [showAlchoDis, setShowAlchoDis] = useState(false);
  const [showAlchoRelat, setShowAlchoRelat] = useState(false);
  const [showThyrDis, setShowThyrDis] = useState(false);
  const [showAthDis, setShowAthDis] = useState(false);
  const [showDiabDis, setShowDiabDis] = useState(false);
  const [showSymDis, setShowSymDis] = useState(false);
  const [showGynoDis, setShowGynoDis] = useState(false);
  const [showOnGoMedic, setShowOnGoMedic] = useState(false);
  const [showTobacoDis, setshowTobacoDis] = useState(false);
  const [showHyperDis, setshowHyperDis] = useState(false);
  const [showHyperlidDis, setshowHyperlidDis] = useState(false);
  const [selectedRelationships, setSelectedRelationships] = useState([]);
  const [selectedAsthRelationship, setSelectedAsthRelationship] = useState([]);

  const [NullQuestArry, setNullQuestArry] = useState(StoredQuestions?.
    healtQuesSpousenull || StoredQuestions?.healtQuesSelfnull ? StoredQuestions?.
    healtQuesSpousenull || StoredQuestions?.healtQuesSelfnull : NullQuestions);
  const [ComQuestions, setQuestions] = useState(StoredQuestions?.
    Spouse ? StoredQuestions?.
    Spouse : Questions);
  const [SelfQuestArry, setSelfQuestArry] = useState(StoredQuestions?.
    healtQuesSelf ? StoredQuestions?.healtQuesSelf : Questions);
  const [SpouseQuestArry, setSpouseQuestArry] = useState(StoredQuestions?.
    Spouse ? StoredQuestions?.
    Spouse : Questions);

    const filteredPersons = PersonsDetail?.filter(item => item?.relationship !== 'Son' && item?.relationship !== 'Daughter');
  // console.log(filteredPersons);

  // console.log('StoredQuestions',StoredQuestions)
  // console.log('NullQuestArry',NullQuestArry)

  useEffect(()=> {
    if (NoForAll === true) {
        setShowAlchoDis(false);
        setShowAthDis(false);
        setShowDiabDis(false);
        setShowSymDis(false);
        setShowGynoDis(false);
        setShowGynoDis(false);
        setShowOnGoMedic(false);
        setshowTobacoDis(false);
        setShowThyrDis(false);
        setshowHyperDis(false);
        setshowHyperlidDis(false);
      form.setFieldsValue({
        alchocol: false,
        asthma: false,
        diabetes: false,
        undiagnosed: false,
        Gynaecological: false,
        goingMedication: false,
        tobacco: false,
        thyroid: false,
        Hypertension: false,
        Hyperlipidemia: false,
      });
    } else {
      form.setFieldsValue({
        alchocol: null,
        asthma: null,
        diabetes: null,
        undiagnosed: null,
        Gynaecological: null,
        goingMedication: null,
        tobacco: null,
        thyroid: null,
        Hypertension: null,
        Hyperlipidemia: null,
      });
    }
  },[NoForAll])

  
  const onDiseaseChange = (e) => {
    // console.log(e.target.value);
    const DIValue = e.target.value;
    if (DIValue === true) {
        setShowAlchoDis(true);
      // setShowAlchoRelat(true)
      form.setFieldsValue({ questions :null})
    } else if (DIValue === false) {
      setShowAlchoDis(false);
      setShowAlchoRelat(false)
    }
  };
  const onAsthChange = (e) => {
    // console.log(e.target.value);
    const DIValue = e.target.value;
    if (DIValue === true) {
      setShowAthDis(true);
      form.setFieldsValue({ questions :null})
    } else if (DIValue === false) {
      setShowAthDis(false);
    }
  };
  const onDiabChange = (e) => {
    // console.log(e.target.value);
    const DIValue = e.target.value;
    if (DIValue === true) {
      setShowDiabDis(true);
      form.setFieldsValue({ questions :null})
    } else if (DIValue === false) {
      setShowDiabDis(false);
    }
  };
  const onSympChange = (e) => {
    // console.log(e.target.value);
    const DIValue = e.target.value;
    if (DIValue === true) {
      setShowSymDis(true);
      form.setFieldsValue({ questions :null})
    } else if (DIValue === false) {
      setShowSymDis(false);
    }
  };
  const onGynoChange = (e) => {
    // console.log(e.target.value);
    const DIValue = e.target.value;
    if (DIValue === true) {
      setShowGynoDis(true);
      form.setFieldsValue({ questions :null})
    } else if (DIValue === false) {
      setShowGynoDis(false);
    }
  };
  const onGoingMedicChange = (e) => {
    // console.log(e.target.value);
    const DIValue = e.target.value;
    if (DIValue === true) {
      setShowOnGoMedic(true);
      form.setFieldsValue({ questions :null})
    } else if (DIValue === false) {
      setShowOnGoMedic(false);
    }
  };
  const onTobacoChange = (e) => {
    // console.log(e.target.value);
    const DIValue = e.target.value;
    if (DIValue === true) {
      setshowTobacoDis(true);
      form.setFieldsValue({ questions :null})
    } else if (DIValue === false) {
      setshowTobacoDis(false);
    }
  };
  const onThyroidChange = (e) => {
    // console.log(e.target.value);
    const DIValue = e.target.value;
    if (DIValue === true) {
      setShowThyrDis(true);
      form.setFieldsValue({ questions :null})
    } else if (DIValue === false) {
      setShowThyrDis(false);
    }
  };
  const onHyperChange = (e) => {
    // console.log(e.target.value);
    const DIValue = e.target.value;
    if (DIValue === true) {
      setshowHyperDis(true);
      form.setFieldsValue({ questions :null})
    } else if (DIValue === false) {
      setshowHyperDis(false);
    }
  };
  const onHyperlidChange = (e) => {
    // console.log(e.target.value);
    const DIValue = e.target.value;
    if (DIValue === true) {
      setshowHyperlidDis(true);
      form.setFieldsValue({ questions :null})
    } else if (DIValue === false) {
      setshowHyperlidDis(false);
    }
  };

//   const handleRelationshipChange = (e) => {
//     const relationship = e.target.value;
//     const updatedRelationships = selectedRelationships.includes(relationship)
//       ? selectedRelationships.filter((rel) => rel !== relationship)
//       : [...selectedRelationships, relationship];
//   console.log('updatedRelationships',updatedRelationships)
//   const onlySelf = updatedRelationships?.length === 1 && updatedRelationships?.includes("Self");
//   console.log(onlySelf)
//   setShowAlchoDis(onlySelf)
//     setSelectedRelationships(updatedRelationships);
//     console.log(updatedRelationships); 
//     form.setFieldsValue({ whoUseAlchocol: updatedRelationships });
//   };
  
//   const handleAsthRelationshipChange = (e) => {
//     const relationship = e.target.value;
//     const updatedRelationships = selectedAsthRelationship.includes(relationship)
//       ? selectedAsthRelationship.filter((rel) => rel !== relationship)
//       : [...selectedAsthRelationship, relationship];
  
//       setSelectedAsthRelationship(updatedRelationships);
//     console.log(updatedRelationships); 
//     form.setFieldsValue({ whoHasAsth: updatedRelationships });
//   };

  const onFinish = (values) => {
    // console.log("product values", values);
    setLoading(true)
    const newHealthQuestions = {};
    console.log('spouseeee')
    // const fullName = AddressDetail?.SpouseData?.SpouseName;
    // const nameParts = fullName.trim().split(' '); 

    // const firstName = nameParts[0]; 
    // const secondName = nameParts.slice(1).join(' '); 

      const updatedQuestions = SpouseQuestArry?.map(question => {
        console.log('question', question);
      
        // Update person details ... (unchanged)
      
        const updatedPerson = {
          ...question,
          firstName: AddressDetail?.Spouse?.SpouseName,
          lastName: 'a',
          dateOfBirth: AddressDetail?.Spouse?.dateofbirth,
          isInsuredPerson: true,
          isPayer: false,
          isPolicyHolder: false,
          isPrimaryInsuredPerson: false,
          isPrimaryPolicyHolder: false,
          relationship: 'SPOUSE'
        };
      
        let updatedQuestion = updatedPerson; // Create a variable to hold the updated question
      
        // Update addresses if they exist
        if (question.hasOwnProperty("addresses")) {
          console.log('addresses')
          const updatedAddresses = question.addresses.map(address => ({
            ...address,
            city: AddressDetail?.Self?.City,
            pincode: AddressDetail?.Self?.Pincode,
            state: AddressDetail?.Self?.State,
            street: AddressDetail?.Self?.Address
          }));
      
          updatedQuestion = {
            ...updatedPerson,
            addresses: updatedAddresses
          };
        }
      
        // Update communications if they exist
        if (question?.communications) {
          console.log('communications')
          const updatedcommunication = question.communications.map((communication, index) => {
            if (index === 0) {
                      return {
                        ...communication,
                        communicationId: AddressDetail?.Self?.Email
                      };
                    } else if (index === 1) {
                      return {
                        ...communication,
                        communicationId: AddressDetail?.Self?.Mobile
                      };
                    } else {
                      return communication;
                    }
          });
      
          updatedQuestion = {
            ...updatedQuestion,
            communications: updatedcommunication
          };
        }
        if (question.hasOwnProperty("medical")) {
          // Update the medicalQuestions with new values (using spread operator and nesting)
          const updatedMedicalQuestions = question.medical.medicalQuestions.map((medicalQuestion, index) => {
            if (index === 2) {
              return {
                ...medicalQuestion, 
                detailAnswer: values?.thyroid,
                subQuestions: medicalQuestion.subQuestions.map((subQuestion, subIndex) => {
                  if (subIndex === 0) {
                    return {
                      ...subQuestion,
                      detailAnswer: values?.thyroidTypes === undefined ? null : values?.thyroidTypes,
                    };
                  } else if (subIndex === 1) {
                        return {
                        ...subQuestion,
                        detailAnswer: values?.thyroidMedication === undefined ? null : values?.thyroidMedication,
                        };
                    } else if (subIndex === 2) {
                        return {
                        ...subQuestion,
                        detailAnswer: values?.thyroidDiagnoseYear === undefined ? null : values?.thyroidDiagnoseYear,
                        };
                    } else if (subIndex === 3) {
                        return {
                        ...subQuestion,
                        detailAnswer: values?.thyroidComplication === undefined ? null : values?.thyroidComplication,
                        };
                    }  else {
                    return subQuestion; // Return unchanged subQuestion
                  }
                }),
              };
            } else if (index === 3) {
                return {
                    ...medicalQuestion,
                    detailAnswer: values?.diabetes,
                    subQuestions: medicalQuestion.subQuestions.map((subQuestion, subIndex) => {
                    if (subIndex === 0) {
                        return {
                        ...subQuestion,
                        detailAnswer: values?.diabetsTypes === undefined ? null : values?.diabetsTypes,
                        };
                    } else if (subIndex === 1) {
                        return {
                        ...subQuestion,
                        detailAnswer: values?.diabetsMedication === undefined ? null : values?.diabetsMedication,
                        };
                    } else if (subIndex === 2) {
                        return {
                        ...subQuestion,
                        detailAnswer: values?.diabetsDiagnoseYear === undefined ? null : values?.diabetsDiagnoseYear,
                        };
                    } else if (subIndex === 3) {
                        return {
                        ...subQuestion,
                        detailAnswer: values?.diabBloodSugarDone === undefined ? null : values?.diabBloodSugarDone,
                        };
                    } else if (subIndex === 5) {
                        return {
                        ...subQuestion,
                        detailAnswer: values?.hospRecordsDiabets === undefined ? null : values?.hospRecordsDiabets,
                        };
                    } else if (subIndex === 6) {
                        return {
                        ...subQuestion,
                        detailAnswer: values?.DiabetsComplication === undefined ? null : values?.DiabetsComplication,
                        };
                    } else if (subIndex === 7) {
                        return {
                        ...subQuestion,
                        detailAnswer: values?.compRecordsDiabets === undefined ? null : values?.compRecordsDiabets,
                        };
                    } else if (subIndex === 8) {
                        return {
                        ...subQuestion,
                        detailAnswer: values?.DiabetsHbA1c === undefined ? null : values?.DiabetsHbA1c,
                        };
                    } else if (subIndex === 9) {
                        return {
                        ...subQuestion,
                        detailAnswer: values?.DiabetsFBS === undefined ? null : values?.DiabetsFBS,
                        };
                    } else {
                        return subQuestion;
                    }
                    
                    }),
                }
            } else if (index === 4) {
                return {
                    ...medicalQuestion,
                    detailAnswer: values?.asthma,
                    subQuestions: medicalQuestion.subQuestions.map((subQuestion, subIndex) => {
                        if (subIndex === 0) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.whenAsthma === undefined ? null : values?.whenAsthma,
                            };
                        } else if (subIndex === 1) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.asthmaMedication === undefined ? null : values?.asthmaMedication,
                            };
                        } else if (subIndex === 2) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.asthmaFrequency === undefined ? null : values?.asthmaFrequency,
                            };
                        } else if (subIndex === 3) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.asthmaHospitalization === undefined ? null : values?.asthmaHospitalization,
                            };
                        } else if (subIndex === 4) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.asthmaRecordHospital === undefined ? null : values?.asthmaRecordHospital,
                            };
                        } else if (subIndex === 5) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.asthmaComplication === undefined ? null : values?.asthmaComplication,
                            };
                        } else if (subIndex === 6) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.compRecordsAsthma === undefined ? null : values?.compRecordsAsthma,
                            };
                        } else {
                        return subQuestion;
                    }
                    
                    }),
                }
            } else if (index === 5) {
                return {
                    ...medicalQuestion,
                    detailAnswer: values?.Hypertension,
                    subQuestions: medicalQuestion.subQuestions.map((subQuestion, subIndex) => {
                        if (subIndex === 0) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.HypertensionDiagnoseYear === undefined ? null : values?.HypertensionDiagnoseYear,
                            };
                        } else if (subIndex === 1) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.HypertensionTablets === undefined ? null : values?.HypertensionTablets,
                            };
                        } else if (subIndex === 2) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.HypertensionSystolic === undefined ? null : values?.HypertensionSystolic,
                            };
                        } else if (subIndex === 3) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.HypertensionDiastolic === undefined ? null : values?.HypertensionDiastolic,
                            };
                        } else if (subIndex === 5) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.HypertensionComplication === undefined ? null : values?.HypertensionComplication,
                            };
                        } else if (subIndex === 6) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.HypertensionComplicationRec === undefined ? null : values?.HypertensionComplicationRec,
                            };
                        } else if (subIndex === 7) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.HypertensionHospitalization === undefined ? null : values?.HypertensionHospitalization,
                            };
                        } else {
                        return subQuestion;
                    }
                    }),
                }
            } else if (index === 6) {
                return {
                    ...medicalQuestion,
                    detailAnswer: values?.Hyperlipidemia,
                    subQuestions: medicalQuestion.subQuestions.map((subQuestion, subIndex) => {
                        if (subIndex === 0) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.HyperlipidemiaMedicationLipids === undefined ? null : values?.HyperlipidemiaMedicationLipids,
                            };
                        } else if (subIndex === 1) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.HyperlipidemiaComplicationsLipids === undefined ? null : values?.HyperlipidemiaComplicationsLipids,
                            };
                        } else if (subIndex === 2) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.HyperlipidemiaDiagnoseYear === undefined ? null : values?.HyperlipidemiaDiagnoseYear,
                            };
                        } else {
                        return subQuestion;
                    }
                    }),
                }
            } else if (index === 7) {
                return {
                    ...medicalQuestion,
                    detailAnswer: values?.goingMedication,
                    subQuestions: medicalQuestion.subQuestions.map((subQuestion, subIndex) => {
                        if (subIndex === 0) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.goMedicationText === undefined ? null : values?.goMedicationText,
                            };
                        }  else {
                        return subQuestion;
                    }
                    }),
                }
            } else if (index === 8) {
                return {
                    ...medicalQuestion,
                    detailAnswer: values?.undiagnosed,
                    subQuestions: medicalQuestion.subQuestions.map((subQuestion, subIndex) => {
                        if (subIndex === 0) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.symptomsName === undefined ? null : values?.symptomsName,
                            };
                        }  else {
                        return subQuestion;
                    }
                    }),
                }
            } else if (index === 9) {
                return {
                    ...medicalQuestion,
                    detailAnswer: values?.Gynaecological,
                    subQuestions: medicalQuestion.subQuestions.map((subQuestion, subIndex) => {
                        if (subIndex === 0) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.gynoCondition === undefined ? null : values?.gynoCondition,
                            };
                        }  else {
                        return subQuestion;
                    }
                    }),
                }
            } else if (index === 10) {
                return {
                    ...medicalQuestion,
                    detailAnswer: values?.tobacco,
                    subQuestions: medicalQuestion.subQuestions.map((subQuestion, subIndex) => {
                        if (subIndex === 0) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.tobaccoForm === undefined ? null : values?.tobaccoForm,
                            };
                        }  else {
                        return subQuestion;
                    }
                    }),
                }
            } else if (index === 11) {
                return {
                    ...medicalQuestion,
                    detailAnswer: values?.alchocol,
                    subQuestions: medicalQuestion.subQuestions.map((subQuestion, subIndex) => {
                        if (subIndex === 0) {
                            return {
                            ...subQuestion,
                            detailAnswer: values?.alchoholValue === undefined ? null : values?.alchoholValue,
                            };
                        }  else {
                        return subQuestion;
                    }
                    }),
                }
            } else {
              return medicalQuestion; // Return unchanged medicalQuestion
            }
          });
          // Create a new question object with the updated medicalQuestions
          updatedQuestion = {
            ...updatedQuestion,
            medical: {
              ...question.medical,
              medicalQuestions: updatedMedicalQuestions,
            },
          };
        } 
        return updatedQuestion;
      });
    console.log("Updated Questions:", updatedQuestions);
    
    newHealthQuestions.Spouse = updatedQuestions
  // setAllData({...AllData, Spouse : newHealthQuestions?.Spouse})
  setTimeout(()=>{
    dispatch(HealthQuestions({...StoredQuestions, Spouse: newHealthQuestions?.Spouse}));
    setLoading(false)
  },500)
  };  
 
  return (
    <>
     <div className="medic-heading">Spouse</div>
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        scrollToFirstError
      >
        <Form.Item name="totalQuestion">
          <div className="py-3 px-3 pb-0 bg-white ant-radio-layout prev-prod-sec-health">
            <div className="row justify-content-center align-items-center mb-2">
              <div className="col-lg-8 col-md-12 parent-ques-head">
                Do you consume alcohol?
              </div>
              <Form.Item
                name="alchocol"
                className="col-lg-3 col-md-12 health-ques"
              >
                <Radio.Group onChange={onDiseaseChange}>
                  <Radio.Button value={true}>Yes</Radio.Button>
                  <Radio.Button value={false}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </div>
            {showAlchoDis ? (
              <>
                <div className="dropdown-disease mb-3">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <Form.Item
                        name="alchoholValue"
                        label="Frequency of alchohol consumption?"
                        rules={[{
                            required: true, 
                            message: 'please select'
                          }]}
                      >
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "AL1C",
                              label: "Occasional or Social",
                            },
                            {
                              value: "AL1A",
                              label: "Once in a week",
                            },
                            {
                              value: "AL1B",
                              label: "Daily",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            <div className="row justify-content-center align-items-center mb-2">
              <div className="col-lg-8 col-md-12 parent-ques-head">
                Do you have Asthma?
              </div>
              <Form.Item
                name="asthma"
                className="col-lg-3 col-md-12 health-ques"
              >
                <Radio.Group
                  // className="col-lg-3 col-md-12 health-ques"
                  onChange={onAsthChange}
                >
                  <Radio.Button value={true}>Yes</Radio.Button>
                  <Radio.Button value={false}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </div>
            {showAthDis ? (
              <>
                <div className="dropdown-disease mb-3">
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='whenAsthma'
                      label="When was it diagnosed?"
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}
                      >
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "AS1A",
                              label: "Upto 10yrs",
                            },
                            {
                              value: "AS1B",
                              label: "More than 10yrs",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='asthmaMedication'
                      label="Current Medication"
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}>
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "AS2C",
                              label: "Non Steroids",
                            },
                            {
                              value: "AS2B",
                              label: "Steroids",
                            },
                            {
                              value: "AS2A",
                              label: "None",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='asthmaFrequency'
                      label="Frequency of episodes in a year"
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}>
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "AS3A",
                              label: "Less than 2",
                            },
                            {
                              value: "AS3C",
                              label: "More than 5",
                            },
                            {
                              value: "AS3B",
                              label: "2-5",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='asthmaHospitalization'
                      label="Any hospitalization due to Asthma?"
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}>
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='asthmaRecordHospital'
                      label="Any records of hospitalization?"
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}>
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='asthmaComplication'
                      label="Any complications due to Asthma?"
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}>
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='compRecordsAsthma'
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}
                      label="Any records of complications?">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            <div className="row justify-content-center align-items-center mb-2">
              <div className="col-lg-8 col-md-12 parent-ques-head">
                Do you have Diabetes?
              </div>
              <Form.Item
                name="diabetes"
                className="col-lg-3 col-md-12 health-ques"
              >
                <Radio.Group
                  // className="col-lg-3 col-md-12 health-ques"
                  onChange={onDiabChange}
                >
                  <Radio.Button value={true}>Yes</Radio.Button>
                  <Radio.Button value={false}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </div>
            {showDiabDis ? (
              <>
                <div className="dropdown-disease mb-3">
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item
                      name='diabetsTypes'
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}
                      label="Type of Diabetes">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "DB1A",
                              label: "Insulin dependant",
                            },
                            {
                              value: "DB1B",
                              label: "Non Insulin dependant",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item
                      name='diabetsMedication'
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}
                      label="Current Medication">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "DB2A",
                              label: "Insulin",
                            },
                            {
                              value: "DB2B",
                              label: "Oral medication",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item
                      name='diabetsDiagnoseYear'
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}
                      label="When was it diagnosed?">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "DB3B",
                              label: "More than 10yrs",
                            },
                            {
                              value: "DB3A",
                              label: "Upto 10yrs",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item label="last Blood sugar test done?">
                        <Select
                        name='diabBloodSugarDone'
                        rules={[{
                          required: true, 
                          message: 'please select'
                        }]}
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Not done in last 6 months",
                            },
                            {
                              value: false,
                              label: "Less than 3 Months",
                            },
                            {
                              value: false,
                              label: "More than 3 Months",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item
                      name='hospRecordsDiabets'
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}
                      label="Any records of hospitalization?">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item label="Any complications for Diabetes?">
                        <Select
                        name='DiabetsComplication'
                        rules={[{
                          required: true, 
                          message: 'please select'
                        }]}
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='compRecordsDiabets'
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}
                      label="Any records of complications?">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='DiabetsHbA1c'
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}
                      label="What was HbA1c value?">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "DB9A",
                              label: "upto 7.5%",
                            },
                            {
                              value: "DB9B",
                              label: "More than 7.5%",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='DiabetsFBS'
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}
                      label="What was FBS value?">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "DB10A",
                              label: "Within normal limits",
                            },
                            {
                              value: "DB10B",
                              label: "Abnormal",
                            },
                            {
                              value: "DB10C",
                              label: "Not listed",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            <div className="row justify-content-center align-items-center mb-2">
              <div className="col-lg-8 col-md-12 parent-ques-head">
                Do you face any symptoms like chest pain, fatigue, weight loss,
                dizziness, joint pain, change in bowel habit, difficulty in
                breathing, pain in abdomen, bleeding/pain while passing stools
                etc?
              </div>
              <Form.Item
                name="undiagnosed"
                className="col-lg-3 col-md-12 health-ques"
              >
                <Radio.Group
                  // className="col-lg-3 col-md-12 health-ques"
                  onChange={onSympChange}
                >
                  <Radio.Button value={true}>Yes</Radio.Button>
                  <Radio.Button value={false}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </div>
            {showSymDis ? (
              <>
                <div className="dropdown-disease mb-3">
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name="symptomsName"
                      rules={[{
                          required: true, 
                          message: 'please select'
                      }]}
                      label="Details of your undiagnosed symptoms?">
                        <Input
                          placeholder="Enter Details"
                        ></Input>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            <div className="row justify-content-center align-items-center mb-2">
              <div className="col-lg-8 col-md-12 parent-ques-head">
                Any Gynaecological problem?
              </div>
              <Form.Item
                name="Gynaecological"
                className="col-lg-3 col-md-12 health-ques"
              >
                <Radio.Group
                  // className="col-lg-3 col-md-12 health-ques"
                  onChange={onGynoChange}
                >
                  <Radio.Button value={true}>Yes</Radio.Button>
                  <Radio.Button value={false}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </div>
            {showGynoDis ? (
              <>
                <div className="dropdown-disease mb-3">
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='gynoCondition'
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}
                      label="what is the name of the condition?">
                        <Input
                          name="GynoCondition"
                          placeholder="Enter Details"
                        ></Input>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            <div className="row justify-content-center align-items-center mb-2">
              <div className="col-lg-8 col-md-12 parent-ques-head">
                Is any member going through any medications currently?
              </div>
              <Form.Item
                name="goingMedication"
                className="col-lg-3 col-md-12 health-ques"
              >
                <Radio.Group
                  // className="col-lg-3 col-md-12 health-ques"
                  onChange={onGoingMedicChange}
                >
                  <Radio.Button value={true}>Yes</Radio.Button>
                  <Radio.Button value={false}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </div>
            {showOnGoMedic ? (
              <>
                <div className="dropdown-disease mb-3">
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='goMedicationText'
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}
                      label="Name of the medicines taken?">
                        <Input
                          name="medicineName"
                          placeholder="Enter Details"
                        ></Input>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            <div className="row justify-content-center align-items-center mb-2">
              <div className="col-lg-8 col-md-12 parent-ques-head">
                Do you consume tobacco?
              </div>
              <Form.Item
                name="tobacco"
                className="col-lg-3 col-md-12 health-ques"
              >
                <Radio.Group
                  // className="col-lg-3 col-md-12 health-ques"
                  onChange={onTobacoChange}
                >
                  <Radio.Button value={true}>Yes</Radio.Button>
                  <Radio.Button value={false}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </div>
            {showTobacoDis ? (
              <>
                <div className="dropdown-disease mb-3">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <Form.Item 
                      name="tobaccoForm"
                      rules={[{
                      required: true, 
                      message: 'please select'
                      }]}
                      label="In which form do you consumes tobacco?">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "TB1B",
                              label: "Chewable",
                            },
                            {
                              value: "TB1A",
                              label: "Smoke",
                            },
                            {
                              value: "TB1C",
                              label: "Both",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            <div className="row justify-content-center align-items-center mb-2">
              <div className="col-lg-8 col-md-12 parent-ques-head">
                Do you have Thyroid?
              </div>
              <Form.Item
                name="thyroid"
                className="col-lg-3 col-md-12 health-ques"
              >
                <Radio.Group
                  // className="col-lg-3 col-md-12 health-ques"
                  onChange={onThyroidChange}
                >
                  <Radio.Button value={true}>Yes</Radio.Button>
                  <Radio.Button value={false}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </div>
            {showThyrDis ? (
              <>
                <div className="dropdown-disease mb-3">
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name="thyroidTypes"
                      rules={[{
                      required: true, 
                      message: 'please select'
                      }]}
                      label="Type of Thyroid dysfunction?">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "TH1A",
                              label: "Hyperthyroidism",
                            },
                            {
                              value: "TH1A",
                              label: "Hypothyroidism",
                            },
                            {
                              value: "TH1C",
                              label: "Not Sure",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name="thyroidMedication"
                      rules={[{
                      required: true, 
                      message: 'please select'
                      }]}
                      label="Curent Medication">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "TH2B",
                              label: "Thyroxine",
                            },
                            {
                              value: "TH2A",
                              label: "Eltroxine",
                            },
                            {
                              value: "TH2C",
                              label: "Not listed",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name="thyroidDiagnoseYear"
                      rules={[{
                      required: true, 
                      message: 'please select'
                      }]}
                      label="When was it diagnosed?">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "TH3C",
                              label: "10yrs or more",
                            },
                            {
                              value: "TH3A",
                              label: "Less than 5yrs",
                            },
                            {
                              value: "TH3B",
                              label: "5 to 9yrs",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name="thyroidComplication"
                      rules={[{
                      required: true, 
                      message: 'please select'
                      }]}
                      label="Any associated complications">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            <div className="row justify-content-center align-items-center mb-2">
              <div className="col-lg-8 col-md-12 parent-ques-head">
                Do you have Hypertension?
              </div>
              <Form.Item
                name="Hypertension"
                className="col-lg-3 col-md-12 health-ques"
              >
                <Radio.Group
                  // className="col-lg-3 col-md-12 health-ques"
                  onChange={onHyperChange}
                >
                  <Radio.Button value={true}>Yes</Radio.Button>
                  <Radio.Button value={false}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </div>
            {showHyperDis ? (
              <>
                <div className="dropdown-disease mb-3">
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                       name="HypertensionDiagnoseYear"
                       rules={[{
                       required: true, 
                       message: 'please select'
                       }]}
                      label="When was it diagnosed?">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "HP1A",
                              label: "Upto 10yrs",
                            },
                            {
                              value: "HP1B",
                              label: "More than 10yrs",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                       name="HypertensionTablets"
                       rules={[{
                       required: true, 
                       message: 'please select'
                       }]}label="No. of tablets">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "HP2B",
                              label: "More than two",
                            },
                            {
                              value: "HP2A",
                              label: "two or Less",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name="HypertensionSystolic"
                      rules={[{
                      required: true, 
                      message: 'please select'
                      }]}
                      label="Systolic Reading">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "HP3B",
                              label: "More than 130 to 149 mm of Hg",
                            },
                            {
                              value: "HP3A",
                              label: "130 mm of Hg or less",
                            },
                            {
                              value: "HP3C",
                              label: "150 mm of Hg or more",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                        name="HypertensionDiastolic"
                        rules={[{
                        required: true, 
                        message: 'please select'
                        }]}
                      label="Diastolic Reading">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "HP4A",
                              label: "90 mm of Hg or less",
                            },
                            {
                              value: "HP4B",
                              label: "90 to 95 mm of Hg",
                            },
                            {
                              value: "HP4C",
                              label: "More than 95 mm of Hg",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                        name="HypertensionComplicationRec"
                        rules={[{
                        required: true, 
                        message: 'please select'
                        }]}
                      label="Any records of complications?">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    {/* <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                        name="HypertensionHospitalizeRec"
                        rules={[{
                        required: true, 
                        message: 'please select'
                        }]}
                      label="Records of hospitalization?">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div> */}
                  </div>
                  <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                      name='HypertensionHospitalization'
                      label="Any hospitalization due to Hypertension?"
                      rules={[{
                        required: true, 
                        message: 'please select'
                      }]}>
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                        name="HypertensionComplication"
                        rules={[{
                        required: true, 
                        message: 'please select'
                        }]}
                      label="Any complications related to Hypertension (related to nerves, eyes, heart or kidney)">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            <div className="row justify-content-center align-items-center mb-2">
              <div className="col-lg-8 col-md-12 parent-ques-head">
                Do you have Hyperlipidemia?
              </div>
              <Form.Item
                name="Hyperlipidemia"
                className="col-lg-3 col-md-12 health-ques"
              >
                <Radio.Group
                  // className="col-lg-3 col-md-12 health-ques"
                  onChange={onHyperlidChange}
                >
                  <Radio.Button value={true}>Yes</Radio.Button>
                  <Radio.Button value={false}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </div>
            {showHyperlidDis ? (
              <>
                <div className="dropdown-disease mb-3">
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                        name="HyperlipidemiaMedicationLipids"
                        rules={[{
                        required: true, 
                        message: 'please select'
                        }]}
                      label="On medication for High lipids">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                       name="HyperlipidemiaComplicationsLipids"
                       rules={[{
                       required: true, 
                       message: 'please select'
                       }]}
                      label="Any complications with high lipids">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <Form.Item 
                       name="HyperlipidemiaDiagnoseYear"
                       rules={[{
                       required: true, 
                       message: 'please select'
                       }]}
                      label="When was it diagnosed">
                        <Select
                          placeholder="Select"
                          options={[
                            {
                              value: "DL3B",
                              label: "5 to 9yrs",
                            },
                            {
                              value: "DL3A",
                              label: "Less than 5yrs",
                            },
                            {
                              value: "DL3C",
                              label: "10yrs or more",
                            },
                          ]}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            htmlType="submit"
            className="update-qut-button"
            loading={loading}
          >
            {" "}
            Save
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
